export default {
  // 账户管理-查询所有账户名
  queryAllAccountName: {
    url: 'accountManagement/queryAllAccountName',
    method: 'get',
    desc: '查询所有账户信息'
  },
  // 账户管理-查询账户信息列表
  queryAccount: {
    url: 'accountManagement/queryAccount',
    method: 'post',
    desc: '查询账户信息'
  },
  // 账户管理-校验账户名是否存在
  checkAccountNameIsExist: {
    url: 'accountManagement/checkAccountNameIsExist',
    method: 'get',
    desc: '校验账户名是否存在'
  },
  // 账户管理-添加账户
  addAccount: {
    url: 'accountManagement/addAccount',
    method: 'post',
    desc: '添加账户信息'
  },
  // 账户管理-编辑账户
  editAccount: {
    url: 'accountManagement/editAccount',
    method: 'post',
    desc: '编辑账户信息'
  },
  // 账户管理-删除账户
  deleteAccount: {
    url: 'accountManagement/deleteAccount',
    method: 'get',
    desc: '删除账户信息'
  },

  // 费用请款单-查询创建人
  queryCreator: {
    url: 'requestFunds/queryCreator',
    method: 'get',
    desc: '查询创建人'
  },
  // 费用请款单-查询费用请款单
  queryRequestFundsInfo: {
    url: 'requestFunds/queryRequestFundsInfo',
    method: 'post',
    desc: '查询费用请款单'
  },
  // 费用请款单-总结
  queryTotalFee: {
    url: 'requestFunds/queryTotalFee',
    method: 'post',
    desc: '总计'
  },
  // 费用请款单-提交请款单
  commitRequestFunds: {
    url: 'requestFunds/commitEditData',
    method: 'post',
    desc: '提交请款单'
  },
  // 费用请款单-保存草稿
  saveDraft: {
    url: 'requestFunds/saveDraft',
    method: 'post',
    desc: '保存草稿'
  },
  // 费用请款单-提交
  commit: {
    url: 'requestFunds/commit',
    method: 'post',
    desc: '提交'
  },
  // 费用请款单-删除
  deleteRequestFunds: {
    url: 'requestFunds/deleteRequestFunds',
    method: 'post',
    desc: '删除'
  },
  // 费用请款单-审核
  auditRequestFunds: {
    url: 'requestFunds/auditRequestFunds',
    method: 'post',
    desc: '审核'
  },
  // 费用请款单-驳回
  rejectRequestFunds: {
    url: 'requestFunds/rejectRequestFunds',
    method: 'post',
    desc: '驳回'
  },
  // 费用请款单-查询账户信息
  querySimpleAccount: {
    url: 'accountManagement/querySimpleAccount',
    method: 'post',
    desc: '查询账户信息'
  },
  // 费用请款单-付款
  payRequestFunds: {
    url: 'requestFunds/payRequestFunds',
    method: 'post',
    desc: '付款'
  },

  // 费用请款单-查询币种信息
  queryCurrencyCodeInfo: {
    url: 'accountManagement/queryCurrencyCodeInfo',
    method: 'get',
    desc: '查询币种信息'
  },

  // 收付款单-查询收付款单信息
  queryReceiptPaymentList: {
    url: 'receiptAndPayment/queryReceiptPaymentList',
    method: 'post',
    desc: '查询收付款单信息'
  },
  // 收付款单-删除
  receiptAndPaymentCommit: {
    url: 'receiptAndPayment/commit',
    method: 'post',
    desc: '新增/保存收付款单'
  },
  // 收付款单-删除
  delete: {
    url: 'receiptAndPayment/delete',
    method: 'post',
    desc: '删除'
  },
  // 收付款单-审核
  audit: {
    url: 'receiptAndPayment/audit',
    method: 'post',
    desc: '审核'
  },
  // 收付款单-驳回
  reject: {
    url: 'receiptAndPayment/reject',
    method: 'post',
    desc: '驳回'
  },
  // 收付款单-查询总支出总收入
  caculateAccountAmount: {
    url: 'receiptAndPayment/caculateAccountAmount',
    method: 'post',
    desc: '查询总支出总收入'
  },
  // 费用请款单-查询往来单位接口
  queryCorrespondenceCompanyName: {
    url: 'requestFunds/queryCorrespondenceCompanyName',
    method: 'post',
    desc: '查询往来单位接口'
  },
  // 收付款单-查询往来单位接口
  getCorrespondenceCompanyName: {
    url: 'receiptAndPayment/queryCorrespondenceCompanyName',
    method: 'post',
    desc: '查询往来单位接口'
  },

  // 查询对应工单类型的单据号
  getTicketNo: {
    url: 'requestFunds/queryTicketNo',
    method: 'get',
    desc: '查询对应工单类型的单据号'
  },
  // 根据关联单据类型查关联单据号
  queryLinkTicketNum: {
    url: 'requestFunds/queryLinkTicketNum',
    method: 'post',
    desc: '根据关联单据类型查关联单据号'
  },
  // 费用请款单各状态对应数量
  queryCaculateNumberOfStatus: {
    url: 'requestFunds/caculateNumberOfStatus',
    method: 'get',
    desc: '费用请款单各状态对应数量'
  },
  // 计算收付款单各状态数
  receiptAndPaymentCaculateNumberOfStatus: {
    url: 'receiptAndPayment/caculateNumberOfStatus',
    method: 'get',
    desc: '计算收付款单各状态数'
  },
}
